import React from 'react';
import { ArrowRight, Zap, Target } from 'lucide-react';
import { Button } from './ui/button';
import { companyInfo } from '../data/mock';

const Hero = () => {
  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center bg-white overflow-hidden pt-20">
      {/* Clean minimal background */}
      <div className="absolute inset-0 bg-gradient-to-br from-slate-50 via-white to-blue-50"></div>
      
      {/* Subtle animated circles */}
      <div className="absolute top-20 right-20 w-96 h-96 bg-blue-100 rounded-full opacity-20 blur-3xl"></div>
      <div className="absolute bottom-20 left-20 w-96 h-96 bg-slate-100 rounded-full opacity-20 blur-3xl"></div>

      <div className="container mx-auto px-4 py-20 relative z-10">
        <div className="max-w-5xl mx-auto text-center">
          {/* Badge */}
          <div className="inline-flex items-center space-x-2 bg-blue-50 border border-blue-200 px-6 py-3 rounded-full mb-8">
            <Zap className="w-5 h-5 text-blue-500" />
            <span className="text-sm font-bold text-slate-700">Built for Today. Ready for Tomorrow.</span>
          </div>

          {/* Main Heading */}
          <h1 className="text-6xl md:text-7xl font-black text-slate-900 mb-6 leading-tight">
            <span className="block mb-2">{companyInfo.name}</span>
            <span className="text-blue-500">
              {companyInfo.tagline}
            </span>
          </h1>

          {/* Description */}
          <p className="text-xl md:text-2xl text-slate-600 mb-12 max-w-3xl mx-auto leading-relaxed">
            A fresh startup backed by <span className="text-blue-500 font-bold">years of professional experience</span>. 
            We bring enterprise-level expertise to every project.
          </p>

          {/* CTA Buttons with hover effects */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16">
            <Button
              onClick={() => scrollToSection('#services')}
              className="bg-blue-500 hover:bg-blue-600 text-white px-10 py-6 text-lg font-bold rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 group"
            >
              Explore Services
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Button>
            <Button
              onClick={() => scrollToSection('#contact')}
              className="border-2 border-slate-300 bg-white text-slate-700 hover:bg-slate-50 hover:border-slate-400 px-10 py-6 text-lg font-bold rounded-lg shadow-md hover:shadow-lg transition-all duration-300"
            >
              Get in Touch
            </Button>
          </div>

          {/* Stats - Removed Expert Team */}
          <div className="grid grid-cols-2 gap-6 max-w-3xl mx-auto">
            <div className="bg-white p-8 rounded-xl border-2 border-slate-200 shadow-sm hover:shadow-lg hover:border-blue-300 transition-all duration-300">
              <Target className="w-10 h-10 text-blue-500 mx-auto mb-3" />
              <div className="text-5xl font-black text-slate-900 mb-2">9+</div>
              <div className="text-slate-600 font-semibold">Services</div>
            </div>
            <div className="bg-white p-8 rounded-xl border-2 border-slate-200 shadow-sm hover:shadow-lg hover:border-blue-300 transition-all duration-300">
              <Zap className="w-10 h-10 text-blue-500 mx-auto mb-3" />
              <div className="text-5xl font-black text-slate-900 mb-2">2024</div>
              <div className="text-slate-600 font-semibold">Established</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;